export const GET_AUTH_USERS = 'GET_AUTH_USERS';
export const GET_AUTH_USERS_SUCCESS = 'GET_AUTH_USERS_SUCCESS';
export const GET_AUTH_USERS_ERROR = 'GET_AUTH_USERS_ERROR';

export const GET_AUTH_USER = 'GET_AUTH_USER';
export const GET_AUTH_USER_SUCCESS = 'GET_AUTH_USER_SUCCESS';
export const GET_AUTH_USER_ERROR = 'GET_AUTH_USER_ERROR';

export const UPDATE_USER_KYC = "UPDATE_USER_KYC";
export const UPDATE_USER_KYC_SUCCESS = "UPDATE_USER_KYC_SUCCESS";
export const UPDATE_USER_KYC_ERROR = "UPDATE_USER_KYC_ERROR";

export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const UPDATE_USER_NAME_SUCCESS = "UPDATE_USER_NAME_SUCCESS";
export const UPDATE_USER_NAME_ERROR = "UPDATE_USER_NAME_ERROR";

export const VERIFY_BVN = "VERIFY_BVN";
export const VERIFY_BVN_SUCCESS = "VERIFY_BVN_SUCCESS";
export const VERIFY_BVN_ERROR = "VERIFY_BVN_ERROR";

export const GET_COUNTRY = "GET_COUNTRY";
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS";
export const GET_COUNTRY_ERROR = "GET_COUNTRY_ERROR";

export const GET_STATE = "GET_STATE";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_ERROR = "GET_STATE_ERROR";

export const GET_LGA = "GET_LGA";
export const GET_LGA_SUCCESS = "GET_LGA_SUCCESS";
export const GET_LGA_ERROR = "GET_LGA_ERROR";

export const SEND_OTP = "SEND_OTP";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_ERROR = "SEND_OTP_ERROR";

export const GET_BANKS = "GET_BANKS";
export const GET_BANKS_SUCCESS = "GET_BANKS_SUCCESS";
export const GET_BANKS_ERROR = "GET_BANKS_ERROR";

export const VALIDATE_OTP = "VALIDATE_OTP";
export const VALIDATE_OTP_SUCCESS = "VALIDATE_OTP_SUCCESS";
export const VALIDATE_DIR_OTP_SUCCESS = "VALIDATE_DIR_OTP_SUCCESS";
export const VALIDATE_OTP_ERROR = "VALIDATE_OTP_ERROR";

export const SEND_COMPANY_OTP = "SEND_COMPANY_OTP";
export const SEND_COMPANY_OTP_SUCCESS = "SEND_COMPANY_OTP_SUCCESS";
export const SEND_COMPANY_OTP_ERROR = "SEND_COMPANY_OTP_ERROR";


export const CLEAR_OTP = "CLEAR_OTP";

export const GET_COMPANY_DOCS = "GET_COMPANY_DOCS";
export const GET_COMPANY_DOCS_SUCCESS = "GET_COMPANY_DOCS_SUCCESS";
export const GET_COMPANY_DOCS_ERROR = "GET_COMPANY_DOCS_ERROR";

export const GET_BANK_DETAILS = "GET_BANK_DETAILS";
export const GET_BANK_DETAILS_SUCCESS = "GET_BANK_DETAILS_SUCCESS";
export const GET_BANK_DETAILS_ERROR = "GET_BANK_DETAILS_ERROR";

export const GET_WITHDRAW_REASON = "GET_WITHDRAW_REASON";
export const GET_WITHDRAW_REASON_SUCCESS = "GET_WITHDRAW_REASON_SUCCESS";
export const GET_WITHDRAW_REASON_ERROR = "GET_WITHDRAW_REASON_ERROR";

export const GET_USER_DOCS = "GET_USER_DOCS";
export const GET_USER_DOCS_SUCCESS = "GET_USER_DOCS_SUCCESS";
export const GET_USER_DOCS_ERROR = "GET_USER_DOCS_ERROR";

export const GET_ALL_GENDER = "GET_ALL_GENDER";
export const GET_ALL_GENDER_SUCCESS = "GET_ALL_GENDER_SUCCESS";
export const GET_ALL_GENDER_ERROR = "GET_ALL_GENDER_ERROR";

export const GET_ALL_SOURCES = "GET_ALL_SOURCES";
export const GET_ALL_SOURCES_SUCCESS = "GET_ALL_SOURCES_SUCCESS";
export const GET_ALL_SOURCES_ERROR = "GET_ALL_SOURCES_ERROR";

export const GET_ALL_ID_TYPES = "GET_ALL_ID_TYPES";
export const GET_ALL_ID_TYPES_SUCCESS = "GET_ALL_ID_TYPES_SUCCESS";
export const GET_ALL_ID_TYPES_ERROR = "GET_ALL_ID_TYPES_ERROR";

export const CLOSE_MODAL = "CLOSE_MODAL"

export const CLEAR_MESSAGES = "CLEAR_MESSAGES"

export const CLEAR_USERS = 'CLEAR_USERS';
export const REMOVE_FOOTER = 'REMOVE_FOOTER';
export const CLEAR_BVN = "CLEAR_BVN";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";